<script lang="ts">
    import { reactive } from 'vue';
    import { uid } from '@utils';
    import vm, { JourneyLines, JourneyNodes, JourneyNode, JourneyTextNode } from '@journeys/Journeys.viewmodel';
    import { NodeType } from '@journeys/Enums';
    import JourneyLineGroup from './JourneyLine.vue';
    import Node from './JourneyNode.vue';
    import TextNode from './JourneyTextNode.vue';
    import PresetColors from '@shared/components/ColorPickers/PresetColors';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'CanvasLayer_Lines',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const cid = uid();

    const props = withDefaults(
        defineProps<{
            nodes: JourneyNodes;
            data: JourneyLines;
            nodeList: JourneyNodes;
        }>(),
        {}
    );

    const { settings, editor, canvas } = vm,
        /** local state */
        state = reactive({
            busy: false,
        });

    const line_colors = [
        { clr: 126, tooltip: '' },
        { clr: 6, tooltip: '' },
        { clr: 35, tooltip: '' },
        { clr: 159, tooltip: '' },
    ];
</script>

<template>
    <template v-for="(node, index) in nodes" :key="`jn${node.id}`">
        <TextNode v-if="node.data.type === NodeType.Text" :node="node as JourneyTextNode" :class="[editor.tools.sel_nodes[node.id] && 'selected']" />
        <Node v-else :node="node as JourneyNode" :class="[editor.tools.sel_nodes[node.id] && 'selected', state.busy && 'component-busy']" />
    </template>

    <svg
        class="line-canvas ZD_MIDDLE"
        :class="[state.busy && 'component-busy', editor.dev.show.hitboxes && 'dev_show-hitboxes']"
        xmlns="http://www.w3.org/2000/svg">
        <defs>
            <marker
                v-for="{ clr } of line_colors"
                v-once
                :id="`arrow${clr}`"
                class="line-arrow-marker"
                viewBox="0 0 10 10"
                refX="5"
                refY="5"
                markerWidth="12"
                markerHeight="12"
                orient="auto-start-reverse"
                markerUnits="userSpaceOnUse">
                <path d="M 0 0 L 7 5 L 0 10 L 3 5 z" stroke-width="0" :fill="PresetColors[clr as 1].hsl" />
            </marker>
        </defs>

        <JourneyLineGroup
            v-for="line in data"
            :key="line.id"
            :line="line"
            :movePoint="() => {}"
            :removePoint="() => {}"
            :removeLine="() => {}"
            :addPoint="() => {}"
            :colors="line_colors" />
    </svg>
</template>
